export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const TREE_LIST = 'TREE_LIST';
export const ADD_CONTENTS = 'ADD_CONTENTS';
export const ADD_LOGS = 'ADD_LOGS';
export const ADD_COMPILES = 'ADD_COMPILES';
export const DELETE_CONTENTS = 'DELETE_CONTENTS';

export default {
	DEFAULT_ASSIGN,
	TREE_LIST,
	ADD_CONTENTS,
	ADD_LOGS,
	ADD_COMPILES,
	DELETE_CONTENTS
};
